import { create } from "zustand";

export const useChatDialogsStore = create((set) => ({
  filter: false,
  changeName: false,
  contact: false,
  area: false,
  reassign: false,
  notifications: false,
  reactivateBot: false,
  comment: false,
  leadQuality: false,
  shareChat: false,
  disabledButtons: false,
  labelInfo: false,
  exportLeads: false,
  confirmCloseChat: false,
  addToContacts: false,
  contactInfo: false,

  open: (dialog) => set({ [dialog]: true }),

  close: (dialog) => set({ [dialog]: false }),
}));